// Calculate reading time for blog posts
function calculateReadingTime() {
  // Check if we're on a blog post page
  if (!document.body.classList.contains('rbs-article-blog-post')) {
    return;
  }

  // Get content from main article and intro
  const articleContent = document.querySelector('.article-template__content');
  const blogIntro = document.querySelector('.blog-post-intro');
  
  if (!articleContent && !blogIntro) {
    return;
  }

  // Combine all text content
  let fullText = '';
  
  if (blogIntro) {
    fullText += blogIntro.textContent;
  }
  
  if (articleContent) {
    fullText += articleContent.textContent;
  }

  // Calculate reading time
  // Average reading speed: 200-250 words per minute
  const wordsPerMinute = 225;
  const wordCount = fullText.trim().split(/\s+/).length;
  const readingTimeMinutes = Math.ceil(wordCount / wordsPerMinute);
  const readingTimeSeconds = Math.round((wordCount % wordsPerMinute) / (wordsPerMinute / 60));

  // Format the reading time
  let readingTimeText = `${readingTimeMinutes} min`;
  if (readingTimeSeconds > 0) {
    readingTimeText += ` ${readingTimeSeconds} sec`;
  }

  return readingTimeText;
}

// Initialize reading time calculation when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  const readingTime = calculateReadingTime();
  if (readingTime) {
    // Find the hero-video element
    const heroVideo = document.querySelector('.hero-video');
    if (heroVideo) {
      // Create reading time div
      const readingTimeSection = document.createElement('section');
      readingTimeSection.className = 'reading-time-section';
      const readingTimeDiv = document.createElement('div');
      readingTimeDiv.className = 'reading-time';
      const readingTimeInnerDiv = document.createElement('div');
      readingTimeInnerDiv.className = 'reading-time-inner';
      
      const svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M8.4375 3.39976C7.26233 2.64703 5.89557 2.24794 4.5 2.25001C3.66974 2.24916 2.84542 2.38993 2.0625 2.66626C1.95284 2.70503 1.8579 2.77684 1.79074 2.8718C1.72359 2.96676 1.68752 3.0802 1.6875 3.19651V13.884C1.68751 13.974 1.70911 14.0627 1.75049 14.1426C1.79186 14.2225 1.8518 14.2913 1.92527 14.3432C1.99875 14.3952 2.08361 14.4287 2.17274 14.4411C2.26187 14.4535 2.35266 14.4443 2.4375 14.4143C3.1 14.1806 3.7975 14.0616 4.5 14.0625C5.99625 14.0625 7.36725 14.5928 8.4375 15.477V3.39976ZM9.5625 15.477C10.6698 14.5606 12.0627 14.0602 13.5 14.0625C14.2245 14.0625 14.9175 14.187 15.5625 14.415C15.6474 14.445 15.7383 14.4542 15.8274 14.4418C15.9166 14.4294 16.0015 14.3958 16.075 14.3438C16.1485 14.2917 16.2084 14.2228 16.2498 14.1428C16.2911 14.0628 16.3126 13.9741 16.3125 13.884V3.19651C16.3125 3.0802 16.2764 2.96676 16.2093 2.8718C16.1421 2.77684 16.0472 2.70503 15.9375 2.66626C15.1546 2.38993 14.3303 2.24916 13.5 2.25001C12.1044 2.24794 10.7377 2.64703 9.5625 3.39976V15.477Z" fill="#5E88A9"/>
      </svg>`;
      
      readingTimeInnerDiv.innerHTML = `${svgIcon} Reading Time: ${readingTime}`;
      
      // Append inner div inside outer div
      readingTimeDiv.appendChild(readingTimeInnerDiv);
      readingTimeSection.appendChild(readingTimeDiv);
      
      // Insert after hero-video
      heroVideo.insertAdjacentElement('afterend', readingTimeSection);
    }
  }
});

// Create a Table of Contents
function createTableOfContents() {
  // Check if we're on a blog post page
  if (!document.body.classList.contains('rbs-article-blog-post')) {
    return;
  }

  // Get the article template container
  const articleTemplate = document.querySelector('.article-template');
  if (!articleTemplate) return;

  // Get all H2 headings from within article-template
  const h2Headings = articleTemplate.querySelectorAll('h2');
  if (h2Headings.length === 0) return;

  // Create main container
  const tocContainer = document.createElement('div');
  tocContainer.id = 'table-of-contents';

  // Create inner container
  const tocInner = document.createElement('div');
  tocInner.className = 'table-of-contents-wrapper';
  const h2 = document.createElement('h2');
  h2.className = 'table-of-contents-h2';
  h2.textContent = 'Table of Contents';

  // Create titles container
  const tocTitles = document.createElement('div');
  tocTitles.className = 'table-of-contents-titles';

  // Process each H2 and its related H3s
  h2Headings.forEach((h2, index) => {
    // Create ID for H2 if it doesn't exist
    if (!h2.id) {
      h2.id = h2.textContent.toLowerCase().replace(/\s+/g, '-');
    }

    // Create H2 entry with link
    const h2Entry = document.createElement('div');
    h2Entry.className = 'toc-h2';
    const h2Link = document.createElement('a');
    h2Link.href = `#${h2.id}`;
    h2Link.textContent = h2.textContent;
    h2Entry.appendChild(h2Link);
    tocTitles.appendChild(h2Entry);

    // Find all H3s between this H2 and the next H2
    let currentElement = h2.nextElementSibling;
    const nextH2 = h2Headings[index + 1];
    const h3s = [];

    while (currentElement && (!nextH2 || currentElement !== nextH2)) {
      if (currentElement.tagName === 'H3') {
        h3s.push(currentElement);
      }
      currentElement = currentElement.nextElementSibling;
    }

    // Add H3 entries if any exist
    if (h3s.length > 0) {
      const h3Container = document.createElement('div');
      h3Container.className = 'toc-h3s';
      h3s.forEach(h3 => {
        // Create ID for H3 if it doesn't exist
        if (!h3.id) {
          h3.id = h3.textContent.toLowerCase().replace(/\s+/g, '-');
        }

        const h3Entry = document.createElement('div');
        h3Entry.className = 'toc-h3';
        const h3Link = document.createElement('a');
        h3Link.href = `#${h3.id}`;
        h3Link.textContent = h3.textContent;
        h3Entry.appendChild(h3Link);
        h3Container.appendChild(h3Entry);
      });
      tocTitles.appendChild(h3Container);
    }
  });

  // First, add the "Table of Contents" heading to the inner wrapper
  tocInner.appendChild(h2);

  // Then, add the inner wrapper to the main container
  tocContainer.appendChild(tocInner);

  // Finally, add the list of headings to the inner wrapper
  tocInner.appendChild(tocTitles);

  // Insert after blog-post-intro section
  const blogPostIntro = document.querySelector('.blog-post-intro');
  if (blogPostIntro) {
    blogPostIntro.insertAdjacentElement('afterend', tocContainer);
  }
}

// Function to enhance blog references
function enhanceBlogReferences() {
  // Check if we're on a blog post page
  if (!document.body.classList.contains('rbs-article-blog-post')) {
    return;
  }

  // Find the references section
  const referencesSection = document.querySelector('.blog-references');
  if (!referencesSection) return;

  // Get the content container
  const referencesContent = referencesSection.querySelector('.blog-references__content');
  if (!referencesContent) return;

  // Format references if they exist
  if (referencesContent.innerHTML.trim()) {
    console.log('Blog references found, enhancing formatting');
    
    // If references are in a plain text format, convert newlines to proper HTML
    if (!referencesContent.innerHTML.includes('<ol>') && !referencesContent.innerHTML.includes('<ul>')) {
      // Split by newlines and create a numbered list
      const lines = referencesContent.innerHTML.split('\n').filter(line => line.trim() !== '');
      
      if (lines.length > 0) {
        const ol = document.createElement('ol');
        lines.forEach(line => {
          const li = document.createElement('li');
          li.innerHTML = line.trim();
          ol.appendChild(li);
        });
        referencesContent.innerHTML = '';
        referencesContent.appendChild(ol);
      }
    }
    
    // Add ids to each reference for potential linking
    const referenceItems = referencesContent.querySelectorAll('li');
    referenceItems.forEach((item, index) => {
      item.id = `reference-${index + 1}`;
    });
  }
}

// Remove empty <li> and <p> elements with only empty tags, <br>, or whitespace
function removeEmptyContentElements() {
  // Remove empty <li> elements
  document.querySelectorAll('li').forEach(li => {
    const normalized = li.innerHTML.replace(/\s+/g, '');
    if (
      normalized === '' ||
      normalized === '<br>' ||
      normalized === '<strong><br></strong>' ||
      normalized === '<strong></strong>'
    ) {
      li.remove();
    }
  });

  // Remove empty <p> elements (including nested empty tags)
  document.querySelectorAll('p').forEach(p => {
    const normalized = p.innerHTML.replace(/\s+/g, '');
    if (
      normalized === '' ||
      normalized === '<br>' ||
      normalized === '<strong><br></strong>' ||
      normalized === '<strong></strong>' ||
      normalized === '<p></p>' ||
      normalized === '<p><br></p>' ||
      normalized === '<p><strong></strong></p>'
    ) {
      p.remove();
    }
  });

  // Unwrap <p> tags inside <li> (remove <p> but keep its content)
  document.querySelectorAll('li p').forEach(p => {
    while (p.firstChild) {
      p.parentNode.insertBefore(p.firstChild, p);
    }
    p.remove();
  });
}

// Calculate reading time for pages
function calculateReadingTimeForPage() {
  // Check if we're on a page
  if (!document.body.classList.contains('page')) {
    return;
  }

  // Get content from MainContent
  const mainContent = document.querySelector('#MainContent');
  if (!mainContent) return;

  // Get all text content from MainContent
  const fullText = mainContent.textContent || mainContent.innerText;
  
  if (!fullText || fullText.trim().length === 0) return;

  // Calculate reading time
  const wordsPerMinute = 225;
  const wordCount = fullText.trim().split(/\s+/).filter(word => word.length > 0).length;
  const readingTimeMinutes = Math.ceil(wordCount / wordsPerMinute);
  const readingTimeSeconds = Math.round((wordCount % wordsPerMinute) / (wordsPerMinute / 60));

  // Format the reading time
  let readingTimeText = `${readingTimeMinutes} min`;
  if (readingTimeSeconds > 0) {
    readingTimeText += ` ${readingTimeSeconds} sec`;
  }

  // Store reading time in body data attribute for use in featured articles section
  document.body.setAttribute('data-page-reading-time', readingTimeText);
  
  // Also store the word count for reference
  document.body.setAttribute('data-page-word-count', wordCount);
}

// Calculate reading time for blog feed (listing page)
function calculateReadingTimeForFeed() {
  // Check if we're on a blog listing page (not single post)
  if (document.body.classList.contains('rbs-article-blog-post')) {
    return; // Skip if on single post page
  }

  // Find all article cards on the blog feed
  const articleCards = document.querySelectorAll('.article-card-wrapper, .blog-articles__article');
  
  if (articleCards.length === 0) return;

  const wordsPerMinute = 225;
  const svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" class="reading-time-icon">
    <path d="M8.4375 3.39976C7.26233 2.64703 5.89557 2.24794 4.5 2.25001C3.66974 2.24916 2.84542 2.38993 2.0625 2.66626C1.95284 2.70503 1.8579 2.77684 1.79074 2.8718C1.72359 2.96676 1.68752 3.0802 1.6875 3.19651V13.884C1.68751 13.974 1.70911 14.0627 1.75049 14.1426C1.79186 14.2225 1.8518 14.2913 1.92527 14.3432C1.99875 14.3952 2.08361 14.4287 2.17274 14.4411C2.26187 14.4535 2.35266 14.4443 2.4375 14.4143C3.1 14.1806 3.7975 14.0616 4.5 14.0625C5.99625 14.0625 7.36725 14.5928 8.4375 15.477V3.39976ZM9.5625 15.477C10.6698 14.5606 12.0627 14.0602 13.5 14.0625C14.2245 14.0625 14.9175 14.187 15.5625 14.415C15.6474 14.445 15.7383 14.4542 15.8274 14.4418C15.9166 14.4294 16.0015 14.3958 16.075 14.3438C16.1485 14.2917 16.2084 14.2228 16.2498 14.1428C16.2911 14.0628 16.3126 13.9741 16.3125 13.884V3.19651C16.3125 3.0802 16.2764 2.96676 16.2093 2.8718C16.1421 2.77684 16.0472 2.70503 15.9375 2.66626C15.1546 2.38993 14.3303 2.24916 13.5 2.25001C12.1044 2.24794 10.7377 2.64703 9.5625 3.39976V15.477Z" fill="#5E88A9"/>
  </svg>`;

  articleCards.forEach(card => {
    // Skip if reading time already exists
    if (card.querySelector('.article-card__reading-time')) {
      return;
    }

    // Try to get reading time from data attribute (set by Liquid)
    const dataReadingTime = card.getAttribute('data-reading-time');
    
    // Get article content from excerpt or content
    const excerptElement = card.querySelector('.article-card__excerpt');
    const articleInfo = card.querySelector('.article-card__info');
    
    if (!articleInfo) return;

    let readingTimeText = '';
    
    if (dataReadingTime) {
      // Use reading time from Liquid/metafield
      readingTimeText = dataReadingTime;
    } else if (excerptElement) {
      // Calculate from excerpt (approximate for feed)
      const excerptText = excerptElement.textContent || excerptElement.innerText;
      const wordCount = excerptText.trim().split(/\s+/).filter(word => word.length > 0).length;
      
      // Estimate full article length (excerpt is usually ~30 words, so multiply by ~10-15)
      // This is an approximation since we don't have full content on feed
      const estimatedWordCount = wordCount * 12;
      const readingTimeMinutes = Math.max(1, Math.ceil(estimatedWordCount / wordsPerMinute));
      readingTimeText = `${readingTimeMinutes} min`;
    }

    if (readingTimeText) {
      // Create reading time element
      const readingTimeSpan = document.createElement('span');
      readingTimeSpan.className = 'article-card__reading-time';
      readingTimeSpan.innerHTML = `${svgIcon}<span class="reading-time-text">${readingTimeText}</span>`;
      
      // Insert after date/author info
      articleInfo.appendChild(readingTimeSpan);
    }
  });
}

// Initialize table of contents when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  createTableOfContents();
  enhanceBlogReferences();
  calculateReadingTimeForPage();
  calculateReadingTimeForFeed();

  setTimeout(removeEmptyContentElements, 1000);
});

